// extracted by mini-css-extract-plugin
module.exports = {"comments":"PhotoComments_comments___ClkF","single":"PhotoComments_single__ooZA4"};